import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "space" }, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "space" }, null, -1)
const _hoisted_3 = { class: "item-label" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "space" }, null, -1)
const _hoisted_5 = {
  key: 2,
  class: "item-label"
}
const _hoisted_6 = {
  key: 3,
  class: "list-services"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "space" }, null, -1)
const _hoisted_8 = { class: "ws-textbox info-pax" }
const _hoisted_9 = { class: "full-width" }
const _hoisted_10 = { class: "m-0" }
const _hoisted_11 = { class: "select-phone" }
const _hoisted_12 = { class: "control-group" }
const _hoisted_13 = { class: "group-input-label label-center" }
const _hoisted_14 = { class: "mb-3" }
const _hoisted_15 = { class: "m-0" }
const _hoisted_16 = ["placeholder"]
const _hoisted_17 = { class: "group-button" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "space" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ItemOfVoucher = _resolveComponent("ItemOfVoucher")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_SFSListFlightInfo = _resolveComponent("SFSListFlightInfo")!
  const _component_SFSTravelersAndServiceInGroup = _resolveComponent("SFSTravelersAndServiceInGroup")!
  const _component_VueTelInput = _resolveComponent("VueTelInput")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_StyledHome = _resolveComponent("StyledHome")!

  return (_openBlock(), _createBlock(_component_StyledHome, null, {
    default: _withCtx(() => [
      _createVNode(_component_router_link, { to: { name: 'PassengerDetail' } }, {
        default: _withCtx(() => [
          _createVNode(_component_ItemOfVoucher, {
            label: `${_ctx.paxThisIsMe?.first_name} ${_ctx.paxThisIsMe?.last_name}`,
            color: "#a7116f",
            icon: "images/icon-voucher/contact-detail.png",
            pnr: _ctx.paxThisIsMe?.pnr,
            "mobile-url": _ctx.paxThisIsMe?.mobile_url,
            "disable-click": true
          }, null, 8, ["label", "pnr", "mobile-url"])
        ]),
        _: 1
      }),
      _hoisted_1,
      _createVNode(_component_SFSListFlightInfo, { class: "flight-info" }),
      _hoisted_2,
      (_ctx.listGroupPaxExcludeMe.length > 0)
        ? (_openBlock(), _createBlock(_component_SFSTravelersAndServiceInGroup, {
            key: 0,
            label: _ctx.groundHandlerMessage?.homepage_new.SFS_LANG_ROW_30,
            "list-pax": _ctx.listGroupPaxExcludeMe
          }, null, 8, ["label", "list-pax"]))
        : _createCommentVNode("", true),
      (_ctx.vouchers.length > 0)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("span", null, _toDisplayString(_ctx.groundHandlerMessage?.homepage_new.SFS_LANG_ROW_4), 1)
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vouchers, (voucher, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "list-vouchers",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleTo()))
              }, [
                (voucher.service_id !== _ctx.serviceMealPlanId)
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      to: {
            name: voucher.routerName,
            query: voucher?.voucher_code ? Object.assign({}, _ctx.route.query, { voucher_code: voucher.voucher_code }) : _ctx.route.query
          }
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ItemOfVoucher, {
                          label: _ctx.getLabel(voucher.name),
                          color: voucher.color,
                          icon: voucher.icon
                        }, null, 8, ["label", "color", "icon"])
                      ]),
                      _: 2
                    }, 1032, ["to"]))
                  : _createCommentVNode("", true)
              ]))
            }), 128)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vouchers, (voucher, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "list-vouchers",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleTo()))
              }, [
                (voucher.service_id === _ctx.serviceMealPlanId && !_ctx.isNotShowMealPlanService)
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      to: {
            name: voucher.routerName,
            query: voucher?.voucher_code ? Object.assign({}, _ctx.route.query, { voucher_code: voucher.voucher_code }) : _ctx.route.query
          }
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ItemOfVoucher, {
                          label: _ctx.getLabel(voucher.name),
                          color: voucher.color,
                          icon: voucher.icon
                        }, null, 8, ["label", "color", "icon"])
                      ]),
                      _: 2
                    }, 1032, ["to"]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ], 64))
        : _createCommentVNode("", true),
      _hoisted_4,
      (_ctx.isShowCombineVoucher)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("span", null, _toDisplayString(_ctx.groundHandlerMessage?.homepage_new.SFS_LANG_ROW_10), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.isShowCombineVoucher)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(_component_router_link, { to: { name: 'CombineVoucher' } }, {
              default: _withCtx(() => [
                _createVNode(_component_ItemOfVoucher, {
                  label: _ctx.groundHandlerMessage?.homepage_new.SFS_LANG_ROW_11,
                  color: "#0094d5",
                  icon: "images/icon-voucher/combine-voucher.png"
                }, null, 8, ["label"])
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      _hoisted_7,
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", null, [
            _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.groundHandlerMessage?.homepage_new.SFS_LANG_ROW_24), 1),
            _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.groundHandlerMessage?.homepage_new.SFS_LANG_ROW_25), 1),
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_VueTelInput, {
                modelValue: _ctx.phonePax,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.phonePax) = $event)),
                modelModifiers: { trim: true },
                class: _normalizeClass(["vue-tel-input", { 'validation-failed': !_ctx.validatePhone || !_ctx.checkEmptyValue }]),
                "input-options": { placeholder: _ctx.groundHandlerMessage?.homepage_new?.SFS_LANG_ROW_32 || 'Enter phone number' },
                onValidate: _ctx.checkPhoneValid,
                onKeyup: _cache[3] || (_cache[3] = ($event: any) => (_ctx.changePhone()))
              }, null, 8, ["modelValue", "class", "input-options", "onValidate"])
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("span", null, _toDisplayString(_ctx.groundHandlerMessage?.homepage_new?.SFS_LANG_ROW_34 || 'Or'), 1)
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.groundHandlerMessage?.homepage_new.SFS_LANG_ROW_26), 1),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.emailPax) = $event)),
              type: "email",
              placeholder: _ctx.groundHandlerMessage?.homepage_new?.SFS_LANG_ROW_33 || 'Enter email address',
              class: _normalizeClass(["form-control", { 'validation-failed': !_ctx.checkEmptyValue }]),
              onKeyup: _cache[5] || (_cache[5] = ($event: any) => (_ctx.changeEmail()))
            }, null, 42, _hoisted_16), [
              [
                _vModelText,
                _ctx.emailPax,
                void 0,
                { trim: true }
              ]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createVNode(_component_el_button, {
            class: "btn-action",
            disabled: _ctx.sendButtonDisable,
            loading: _ctx.sendButtonLoading,
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.sendSMSAndEmail()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.groundHandlerMessage?.homepage_new.SFS_LANG_ROW_27), 1)
            ]),
            _: 1
          }, 8, ["disabled", "loading"]),
          _createElementVNode("button", {
            class: "btn-action",
            onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.handlePrint && _ctx.handlePrint(...args)))
          }, [
            _createElementVNode("span", null, _toDisplayString(_ctx.groundHandlerMessage?.homepage_new.SFS_LANG_ROW_28), 1)
          ]),
          _createElementVNode("button", {
            class: "btn-action",
            onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.handleBack && _ctx.handleBack(...args)))
          }, [
            _createElementVNode("span", null, _toDisplayString(_ctx.groundHandlerMessage?.homepage_new.SFS_LANG_ROW_29), 1)
          ])
        ])
      ]),
      _hoisted_18
    ]),
    _: 1
  }))
}